import environment from "web/script/modules/environment";

export function getUrl(patternName: string): string | undefined {
    return environment.get("urlPatterns")?.[patternName];
}
